module.exports = __webpack_public_path__ + "static/media/688FoxStNW_2018-06-25_127.783f27bd.jpg";